// extracted by mini-css-extract-plugin
export default {"divider":"CalendarModuleV2_divider__e6QCA","header":"CalendarModuleV2_header__u7c2p","meetingTimeContainer":"CalendarModuleV2_meetingTimeContainer__IpoSN"};